import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  InputGroup,
} from "react-bootstrap";
import "./Refer_and_Earn.css";
import { Referal } from "../../../utils/apis/myAccount/myAccount";

const Refer_and_Earn = () => {
  const [copied, setCopied] = useState(false);
  const [data, setData] = useState({});

  const handleCopy = () => {
    navigator.clipboard.writeText(data?.user?.refer_code || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const getReferralData = async () => {
    const res = await Referal();
    if (res?.success) {
      setData(res.data);
    }
  };

  useEffect(() => {
    getReferralData();
  }, []);

  const referralCode = data?.user?.refer_code || "—";
  const referredUsers = data?.refered_users || [];

  return (
    <section className="refer-and-earn-page">
      <Container fluid="lg">
        {/* Header / Banner */}
        <div className="refer-header">
          <h1 className="page-title">Refer & Earn</h1>
          <p className="subtitle">
            Invite friends and earn <span className="highlight">1%</span> of every profit they make
          </p>
        </div>

        <div className="refer-content-card">
          {/* Referral Code Section */}
          <div className="referral-code-section">
            <h3 className="section-label">Your Referral Code</h3>
            <InputGroup className="referral-input-group">
              <Form.Control
                type="text"
                value={referralCode}
                readOnly
                className="referral-code-input"
              />
              <Button
                variant="outline-primary"
                className={`copy-btn ${copied ? "copied" : ""}`}
                onClick={handleCopy}
              >
                {copied ? "Copied!" : "Copy Code"}
              </Button>
            </InputGroup>
            <p className="referral-hint">
              Share this code with friends — they get started, you earn rewards!
            </p>
          </div>

          {/* Referred Users Table */}
          <div className="referred-users-section">
            <h3 className="section-label">Your Referrals</h3>

            {referredUsers.length > 0 ? (
              <div className="table-responsive">
                <Table className="referrals-table" hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Total Earnings</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referredUsers.map((user, index) => (
                      <tr key={index}>
                        <td className="sr-no">{index + 1}</td>
                        <td className="user-cell">
                          {user?.refer_user?.first_name}{" "}
                          {user?.refer_user?.last_name || "—"}
                        </td>
                        <td className="earnings-cell">
                          ${Number(user?.total || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="no-referrals">
                <p className="no-data-text">No referrals yet</p>
                <p className="no-data-hint">
                  Share your referral code to start earning!
                </p>
              </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Refer_and_Earn;